/**
 * RootLayout
 *
 * Este componente envuelve todas las páginas con el AppLayout.
 * El <Outlet /> es donde se renderiza la página actual según la URL.
 */

import { Outlet } from "react-router-dom";
import { AppLayout } from "./app-layout";

export function RootLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
